export const Title = ({ children, title }) => <div className='flex w-full self-start space-x-3 items-center'>
  {children}
  <div className='text-2xl text-primary font-extrabold self-start'>
    {title}
  </div>
</div>;